import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "auto", // 부드럽게 이동하고 싶으면 'smooth'
    });
  }, [pathname]);

  return null;
}

export default ScrollToTop;
